(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuthItemDeleteController',AuthItemDeleteController);

    AuthItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'AuthItem'];

    function AuthItemDeleteController($uibModalInstance, entity, AuthItem) {
        var vm = this;

        vm.authItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AuthItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
